import React from "react";
import "./App.css";
import PizzaSite from "./components/PizzaSite";

function App() {
  return <PizzaSite />;
}

export default App;
